import apiClient from "./apiClient";

const Url = `/employee`;
const RoleUrl = `/roles`;

export const normalizeRoleList = (payload) => {
    const root = payload?.data ?? payload;
    const list = Array.isArray(root?.roles)
        ? root.roles
        : Array.isArray(root?.data?.roles)
            ? root.data.roles
            : Array.isArray(root)
                ? root
                : [];
    return list
        .map((item) => {
            if (!item) return null;
            if (typeof item === "string") return { _id: item, name: item };
            const name = item.name || item.role || item.title || item.label;
            if (!name) return null;
            return { _id: item._id || name, name };
        })
        .filter(Boolean);
};

export const getRoles = async (props) => {
    try{
        let response = await apiClient.get(`${RoleUrl}/list`);
        if(response && response.status === 200) return response.data;
        return response;
    }catch(error){
        console.log('error', error, error.response);
        return error;
    }
}

export const getEmployees = async (props , currentPage , rowsPerPage , searchText) => {
      try {
    let url = `${Url}/list?page=${currentPage}&limit=${rowsPerPage}`;

    if (searchText !== null && searchText !== undefined && searchText.trim() !== "") {
      url += `&search=${encodeURIComponent(searchText.trim())}`;
    }

    let response = await apiClient.get(url);

    return response.data;
  }catch(error){
        console.log('error', error, error.response);
        return error;
    }
}

export const toggleModal = (thisEvt) => {
    thisEvt.setState({
        addModel: !thisEvt.state.addModel,
        addError: [],
        addName: "",
        addEmail: "",
        addMobile: "",
        addDepartment: "",
        addRole: null,
        addPassword: "",
    })
}

export const handleChange = (e,thisEvt) => {
    thisEvt.setState({
        [e.target.name]: e.target.value
    })
}

export const addEmployee = async (props, thisEvt) => {
    try{
        let body = {
            name: thisEvt.state?.addName,
            email: thisEvt.state?.addEmail,
            mobile: thisEvt.state?.addMobile,
            password: thisEvt.state?.addPassword,
            role : thisEvt.state?.addRole?.name,
            ...(thisEvt.state?.addDepartment
                ? { department: thisEvt.state.addDepartment }
                : {}),
        };
        let response = await apiClient.post(`${Url}/`, body);
        console.log('Add Employee : ',response);
        if(response && response.status === 200) return response;
        return response;
    } catch(error) {
        console.log('error', error, error.response);
        return error;
    }
}

export const editEmployee = async (props, thisEvt) => {
    try{
        let body = {
            "name": thisEvt.state?.editName,
            "email": thisEvt.state?.editEmail,
            "mobile": thisEvt.state?.editMobile,
            "department": thisEvt.state?.editDepartment,
            "role": thisEvt.state?.editRole?.name,
            "userId": thisEvt.state?.userId,
    }
        let response = await apiClient.put(`${Url}/?employeeId=${thisEvt.state?.editId}`, body);
        console.log('Edit Employee : ',response);
        if(response && response.status === 200) return response;
        return response;
    }catch(error){
        console.log('error', error, error.response);
        return error;
    }
}

export const deleteEmployee = async (Deleteid,props) => {
    try{
        let response = await apiClient.delete(`${Url}/?employeeId=${Deleteid}`);
        if(response && response.status === 200) return response.data;
        return response;
    }catch(error){
        console.log('error', error, error.response);
        return error;
    }
}

export const getEmployeeDetail = async (payload, props) => {
    try{
        if(!payload && payload.employeeId) return false;
        let response = await apiClient.get(`${Url}/${payload.employeeId}`);
        if(response && response.status === 200) return response.data;
        return response;
    }catch(error){
        console.log('error', error, error.response);
        return error;
    }
}

/** Admin-only: reset to a generated temporary password (returned once). */
export const resetEmployeePassword = async (id) => {
  try {
    const response = await apiClient.post(`${Url}/reset-password?employeeId=${id}`);
    return response.data;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};
